import { logger } from '@/utility';
import GGSlave from './implementations/seven-gravity-gateway/slave';
import nativeWebview from './implementations/webview';
import nativeWKWebview from './implementations/wkwebview';

const integrator = {
  instance: null,
  _instancePromise() {
    if (this._instanceResolved) {
      return Promise.resolve(this.instance);
    }

    return new Promise((resolve) => {
      this._instancePromiseResolve = () => {
        this._instanceResolved = true;
        resolve();
      };
    });
  },
  _instancePromiseResolve: null,
  _instanceResolved: false,
  init(config) {
    if (config.type === 'gravityGateway') {
      this.instance = GGSlave;
    } else if (config.type === 'webview') {
      this.instance = nativeWebview;
    } else if (config.type === 'wkwebview') {
      this.instance = nativeWKWebview;
    } else {
      logger.error(`Unknown integration implementation: ${config.type}`);
    }

    if (!this._instancePromiseResolve) {
      this._instancePromise();
    }

    return this.instance?.init(config, this._instancePromiseResolve);
  },

  notifyAppLoad() {
    return this.instance?.notifyAppLoad();
  },

  /**
   * @param  {"open"|"close"} event
   * @param  {Game} game
   */
  notifyGameEvent(event, game) {
    return this.instance?.notifyGameEvent(event, game);
  },

  notifyGameImpression(event) {
    return this.instance?.notifyGameImpression(event);
  },

  notifyRouteChange(data) {
    return this.instance?.notifyRouteChange(data);
  },

  notifyChangeTitle(data) {
    return this.instance?.notifyChangeTitle(data);
  },

  notifyGameClickEvent() {
    return this.instance?.notifyGameClickEvent();
  },

  notifyGroupsClickEvent(data) {
    return this.instance?.notifyGroupsClickEvent(data);
  },

  requestGameOpening(data) {
    return this.instance?.requestGameOpening(data);
  },

  requestNavigationChange(url) {
    return this.instance?.requestNavigationChange(url);
  },

  requestReload() {
    this._instancePromise().then(() => {
      return this.instance?.requestReload();
    });
  },

  requireUserLogin(postLoginPayload) {
    return this.instance?.requireUserLogin(postLoginPayload);
  },

  openZiqniWidget() {
    return this.instance?.openZiqniWidget();
  },

  openFastDeposit() {
    return this.instance?.openFastDeposit();
  },

  notifyJackpotWin(data) {
    return this.instance?.notifyJackpotWin(data);
  },

  sendMessage(message) {
    return this.instance?.sendMessage(message);
  },

  subscribe(event, callback) {
    return this.instance?.subscribe(event, callback);
  },
};

export default integrator;
